class EtmTypes {
	static Invalid = 0;
	static Hard = 1;
	static Soft = 2;
	static Reset = 3;
	static Hit = 4;

	static getArrayValidItems() {
		return Object.keys(this).slice(1).map((t, i) => {
			return {
				title: t,
				value: Object.values(this)[i+1]
			}
		});
	}
}

export default EtmTypes;